type AddressOption = {
  text: string;
  id?: string;
  place_id?: string;
};

export const dedupeAddressOptionsByIdOrText = <T extends AddressOption>(
  items: readonly T[],
): T[] =>
  Array.from(
    new Map(
      items.map((item) => [item.place_id || item.id || item.text, item]),
    ).values(),
  );
